import { render } from "./CasePrepBuddy.vue?vue&type=template&id=3111a0b4&scoped=true"
import script from "./CasePrepBuddy.vue?vue&type=script&lang=js"
export * from "./CasePrepBuddy.vue?vue&type=script&lang=js"

import "./CasePrepBuddy.vue?vue&type=style&index=0&id=3111a0b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3111a0b4"]])

export default __exports__